import NotificationHandlerService from './NotificationHandlerService';

export const notificationHanderService = new NotificationHandlerService();
